import React, { useEffect, useReducer, useRef, useState } from 'react';
import { Button, CardMedia, CircularProgress, Grid, Icon, Typography } from '@mui/material';
import Transcriptions from '../views/Transcriptions';
import AudioRecorder from '../AudioRecorder/AudioRecorder';
import RecorderComponent from '../AudioRecorder/FlacRecorder';
import RecordRtcRecorder from '../AudioRecorder/RecorRtcRecorder';
import WebSocketImpl from '../websockets/WebSocket';
import { useParams } from 'react-router';
import WebcamDemo from '../videoDemo/webcamDetection';
import axios from 'axios';
import './mainlayout.css';
import { endpoint } from '../../resource/Constant';
function MainLayout({ fullscrnhandle }) {
  const [response, setResponse] = useState('');
  const params = useParams();
  const id = params.id;
  const user_email = params.user_email;
  const password = params.password;
  const videoRef = useRef();
  const mediaRecorderRef = useRef();
  const [wsState, setWsState] = useState(true);
  const [videointerval, setvideoInterval] = useState();
  const [total_faces, setTotalFaces] = useState();
  const startRecording = () => {
    const stream = videoRef.current.srcObject;
    if (!stream) {
      return;
    }
    const options = { mimeType: 'video/webm' };
    mediaRecorderRef.current = new MediaRecorder(stream, options);
    mediaRecorderRef.current.ondataavailable = async (event) => {
      if (event.data.size > 0) {
        const content = await event.data.arrayBuffer();

        let blob = new Blob([content], {
          type: event.data.type
        });
        const formData = new FormData();
        formData.append('blob_file', blob, 'recording.mp4');
        axios.post(endpoint + '/api/interview/videorecord/' + id, formData).then((res) => {});
      }
    };
    mediaRecorderRef.current.onstart = (event) => {};
    setvideoInterval(
      setInterval(() => {
        mediaRecorderRef.current.start();
        setTimeout(() => {
          mediaRecorderRef.current.stop();
        }, 7000);
      }, 200000)
    );
  };

  const getTotalFaces = (e) => {
    setTotalFaces(e);
  };
  const getVideo = async () => {
    const startWebRTC = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { width: 1280, height: 720 }
        });
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
      } catch (err) {
        console.error('Error accessing webcam:', err);
      }
    };
    startWebRTC();
    startRecording();

    return () => {
      // Clean up WebRTC stream when the component is unmounted
      const stream = videoRef.current?.srcObject;
      if (stream) {
        const tracks = stream.getTracks();
        tracks.forEach((track) => track.stop());
      }
    };
  };

  useEffect(() => {
    getVideo();
  }, []);
  useEffect(() => {
    if (!wsState) {
      clearInterval(videointerval);
    }
  }, [wsState]);

  return (
    <>
      <Grid container spacing={2} padding={5}>
        <div className="loop-text-container" style={{ p: '10px', color: 'red' }}>
          <p className="loop-text" variant="h7">
            <b>Important Instructions for Your Interview:</b>
            <b>1. Do not refresh the page or navigate away</b> – this will pause the interview.
            <b>2. Do not switch between tabs</b> – switching tabs will pause the interview.
            <b>3. Face detection is mandatory</b> – having no face or multiple faces detected will result in the interview being paused.
            <b>4. Permission to record</b> – By starting the interview, you are granting permission to record both audio and video.
          </p>
        </div>
        <Grid item md={8} alignContent={'center'} textAlign={'center'}>
          <Grid>
            <WebcamDemo />
          </Grid>
          <Grid>
            {/* <Video  width={"200px"} ref={videoRef}></video> */}
            <CardMedia style={{ border: 'solid black 2px', display: 'none' }} muted component="video" ref={videoRef} autoPlay />
          </Grid>
        </Grid>
        <Grid
          item
          md={4}
          sx={{
            borderRadius: '10px'
          }}
        >
          <Transcriptions response={response} />
          {/* <AudioRecorder />
          <RecorderComponent /> */}
          <WebSocketImpl
            interview={id}
            password={password}
            user_email={user_email}
            fullscrnhandle={fullscrnhandle}
            startRecordingVideo={startRecording}
            setWsState={setWsState}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default MainLayout;
